<template>
  <button
    class="button"
    :style="{background:color}"
    :class="shape==1 ? 'square' : 'round'"
  >{{value}}</button>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    value: {
      type: String,
      default: "(shape=1方角=2圆角)按钮",
    },
    shape: {
      type: Number,
      default: 1,
    },
    color: {
      type: String,
      default: "#EFBC00",
    },
  },
};
</script>

<style lang="less" scoped>
.square {
  height: 50px;
  border-radius: 10px;
  color: #fff;
  font-size: 18px;
  border: 0;
  cursor: pointer;
}
.round {
  height: 40px;
  border-radius: 20px;
  color: #fff;
  font-size: 16px;
  border: 0;
  cursor: pointer;
}
</style>